import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Globals} from '../../../global/global.model';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';


@Injectable()
export class FotoEquiposServices {

	constructor(private http: HttpClient) { }

	saveFotoEquipo(data:any){
		return this.http.post(Globals.BASE_URL_API_REST+'fotoequipos.json',data);
	}

	deleteFotoEquipo(id:number){
		return this.http.delete(Globals.BASE_URL_API_REST+'fotoequipos/'+id+'.json');
	}


}